import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import LabHeader from './LabHeader';

interface LabExerciseDisplayProps {
  exerciseId: string;
}

interface LabExercise {
  id: string;
  title: string;
  description: string;
  content: string;
}

export default function LabExerciseDisplay({ exerciseId }: LabExerciseDisplayProps) {
  const [exercise, setExercise] = useState<LabExercise | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchExercise() {
      try {
        setLoading(true);
        setError(null);
        
        const { data, error } = await supabase
          .from('lab_exercises')
          .select('*')
          .eq('id', exerciseId)
          .single();
        
        if (error) throw error;
        setExercise(data);
      } catch (err) {
        console.error('Error fetching lab exercise:', err);
        setError('Failed to load lab exercise');
      } finally {
        setLoading(false);
      }
    }
    
    if (exerciseId) {
      fetchExercise();
    }
  }, [exerciseId]);

  if (loading) {
    return <div className="animate-pulse bg-gray-200 h-48 rounded-lg"></div>;
  }

  if (error || !exercise) {
    return null;
  }

  return (
    <div className="lab-exercise-content">
      <LabHeader title={exercise.title} className="mt-0 mb-4" />
      <div>
        <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: exercise.content }} />
      </div>
    </div>
  );
}